import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Cookie } from 'lucide-react';

const COOKIE_CONSENT_KEY = 'cookieConsent';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      // Small delay for smooth entrance
      const timer = setTimeout(() => setIsVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    setIsExiting(true);
    setTimeout(() => {
      localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[9999] transform transition-transform duration-300 ease-out ${
        isExiting ? 'translate-y-full' : 'translate-y-0'
      }`}
      style={{
        animation: isExiting ? undefined : 'slideUp 0.4s ease-out',
      }}
    >
      <div className="bg-[#0B2545]/95 backdrop-blur-md border-t border-white/10 shadow-2xl">
        <div className="container mx-auto px-4 py-4 md:py-3">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Text Content */}
            <div className="flex items-start md:items-center gap-3">
              <Cookie className="h-5 w-5 shrink-0 text-white mt-0.5 md:mt-0" />
              <p className="text-sm leading-relaxed text-white">
                {t('cookie_consent.text')}{' '}
                <Link
                  to="/privacy"
                  className="text-primary hover:text-primary/80 underline underline-offset-2 transition-colors"
                >
                  {t('cookie_consent.privacy_link')}
                </Link>
              </p>
            </div>

            {/* Accept Button */}
            <Button
              onClick={handleAccept}
              className="w-full md:w-auto bg-accent hover:bg-accent/90 text-accent-foreground font-semibold px-6 py-2 rounded-lg shadow-lg hover:shadow-xl transition-all duration-200 touch-target shrink-0"
            >
              {t('cookie_consent.accept')}
            </Button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default CookieConsent;
